<div class="wrap-box">
  <div class="box">
    <div class="row m-0" *ngFor="let item of exampleDatas">
      <div class="col-3 border-rb">
        <div class="pt-15px">
          {{item.title}}
        </div>
      </div>
      <div class="col border-b pl-0">
        <ul class="pt-15px mb-15px">
          <li class="p2" *ngFor="let sub of item.subData">
            <a *ngIf="sub.link" href="{{sub.link}}" target="_blank">
              {{sub.title}}
            </a>
            <div *ngIf="!sub.link">
              {{sub.title}}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
